import React from 'react';
import { EActiveDrawer } from '../../../@types/Enums';
import { useBuilding } from '../../../provider/BuildingProvider/BuildingProvider';
import { useDraggingContext } from '../../../provider/DraggingProvider';
import { useSelection } from '../../../provider/SelectionProvider';
import ArchitectureDrawer from './ArchitectureDrawer';
import AttachmentDrawer from './attachment/AttachmentDrawer';
import CreateElementsDrawer from './CreateElementsDrawer';
import DoorDrawer from './DoorDrawer';
import ElementDrawer from './ElementDrawer';
import FloorDrawer from './FloorDrawer';
import HistoryDrawer from './HistoryDrawer/HistoryDrawer';
import Model2DDrawer from './Model2DDrawer';
import PassageDrawer from './PassageDrawer';
import PartitionWallDrawer from './PartitionWallDrawer';
import ProductDrawer from './ProductDrawer';
import RadiatorDrawer from './RadiatorDrawer';
import RoomComponentsDrawer from './RoomComponentsDrawer';
import SimpleMeasurementDrawer from './SimpleMeasurementDrawer';
import StandardWallDrawer from './StandardWallDrawer';
import TexturesDrawer from './TexturesDrawer';
import WindowDrawer from './WindowDrawer';

const DrawerContainer = () => {
  const {
    selectedStandardWall,
    selectedSpace,
    selectedPartitionWall,
    selectedWindow,
    selectedDoor,
    selectedPassage,
    selectedRadiator,
    selectedSimpleMeasurement,
    selectedProduct,
    selectedElement,
    selectedModel2D,
    selectedHotspot,
    activeDrawer,
    setActiveDrawer,
    resetSelection,
  } = useSelection();
  const { isDragging } = useDraggingContext();
  const { setSelectedModel: setSelectedObject } = useBuilding();

  return (
    <div
      style={{
        userSelect: isDragging ? 'none' : 'auto',
        pointerEvents: isDragging ? 'none' : 'auto',
      }}
    >
      {activeDrawer === EActiveDrawer.FLOOR && (
        <FloorDrawer
          id={`floor-drawer-${selectedSpace.spaceId}`}
          open={activeDrawer === EActiveDrawer.FLOOR}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.WALL && (
        <StandardWallDrawer
          id={`wall-drawer-${selectedStandardWall.wallIndex}`}
          open={activeDrawer === EActiveDrawer.WALL}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          relatedWallIndex={selectedStandardWall.wallIndex}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.PARTITION && (
        <PartitionWallDrawer
          id={`partitionWall-drawer-${selectedPartitionWall.wallIndex}`}
          open={activeDrawer === EActiveDrawer.PARTITION}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          wallIndex={selectedPartitionWall.wallIndex}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.DOOR && (
        <DoorDrawer
          id={`door-drawer-${selectedDoor.wallIndex}-${selectedDoor.doorIndex}`}
          open={activeDrawer === EActiveDrawer.DOOR}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          selectedDoor={selectedDoor}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.WINDOW && (
        <WindowDrawer
          id={`window-drawer-${selectedWindow.wallIndex}-${selectedWindow.windowIndex}`}
          open={activeDrawer === EActiveDrawer.WINDOW}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          selectedWindow={selectedWindow}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.PASSAGE && (
        <PassageDrawer
          id={`passage-drawer-${selectedPassage.wallIndex}-${selectedPassage.passageIndex}`}
          open={activeDrawer === EActiveDrawer.PASSAGE}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          selectedPassage={selectedPassage}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.RADIATOR && (
        <RadiatorDrawer
          key={`radiator-drawer-${selectedRadiator.wallIndex}-${selectedRadiator.side}-${selectedRadiator.radiatorIndex}`}
          id={`radiator-drawer-${selectedRadiator.wallIndex}-${selectedRadiator.side}-${selectedRadiator.radiatorIndex}`}
          open={activeDrawer === EActiveDrawer.RADIATOR}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          selectedRadiator={selectedRadiator}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.ARCHITECTURE && (
        <ArchitectureDrawer id={`architecture-drawer`} open={activeDrawer === EActiveDrawer.ARCHITECTURE} onClose={() => setActiveDrawer(EActiveDrawer.NONE)} />
      )}
      {activeDrawer === EActiveDrawer.CREATE_ELEMENTS && (
        <CreateElementsDrawer id={`createElements-drawer`} open={activeDrawer === EActiveDrawer.CREATE_ELEMENTS} onClose={() => setActiveDrawer(EActiveDrawer.NONE)} />
      )}
      {activeDrawer === EActiveDrawer.TEXTURES && (
        <TexturesDrawer
          id="textures-drawer"
          open={activeDrawer === EActiveDrawer.TEXTURES}
          onClose={() => {
            setActiveDrawer(EActiveDrawer.NONE);
            setSelectedObject(null);
          }}
        />
      )}
      {activeDrawer === EActiveDrawer.PRODUCTS && (
        <ProductDrawer
          id={`product-drawer-${selectedProduct.selectedProductIndex}`}
          open={activeDrawer === EActiveDrawer.PRODUCTS}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          selectedProduct={selectedProduct}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.MODEL2D && (
        <Model2DDrawer
          id={`model2d-drawer-${selectedModel2D.selectedModel2DIndex}`}
          open={activeDrawer === EActiveDrawer.MODEL2D}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          selectedModel2D={selectedModel2D}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.ELEMENT && (
        <ElementDrawer
          id={`product-drawer-${selectedElement.selectedElementIndex}`}
          open={activeDrawer === EActiveDrawer.ELEMENT}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          selectedElement={selectedElement}
          resetSelection={resetSelection}
        />
      )}
      {activeDrawer === EActiveDrawer.SIMPLE_MEASUREMENT && (
        <SimpleMeasurementDrawer
          id={`simplemeasurement-drawer-${selectedSimpleMeasurement.simpleMeasurementIndex}`}
          open={activeDrawer === EActiveDrawer.SIMPLE_MEASUREMENT}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
        />
      )}
      {activeDrawer === EActiveDrawer.ROOM_COMPONENTS && (
        <RoomComponentsDrawer id={`roomcomponents-drawer`} open={activeDrawer === EActiveDrawer.ROOM_COMPONENTS} onClose={() => setActiveDrawer(EActiveDrawer.NONE)} />
      )}
      {activeDrawer === EActiveDrawer.HISTORY && (
        <HistoryDrawer id={`history-drawer`} isOpen={activeDrawer === EActiveDrawer.HISTORY} onClose={() => setActiveDrawer(EActiveDrawer.NONE)} />
      )}
      {activeDrawer === EActiveDrawer.ATTACHMENT && (
        <AttachmentDrawer
          id={`hotspot-drawer-${selectedHotspot.hotspotId}`}
          open={activeDrawer === EActiveDrawer.ATTACHMENT}
          hotspotId={selectedHotspot.hotspotId}
          onClose={() => setActiveDrawer(EActiveDrawer.NONE)}
          resetSelection={resetSelection}
        />
      )}
    </div>
  );
};

export default DrawerContainer;
